import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, ScanSearch } from "lucide-react";
import { Logo } from "./Logo";

const LINKS = [
  { label: "Scanner", to: "/scan", id: "scanner" },
  { label: "Features", to: "/#features", id: "features" },
  { label: "About", to: "/#about", id: "about" },
  { label: "$TRACE", to: "/#token", id: "token" },
  { label: "Developers", to: "/developers", id: "api" },
];

const NavItem = ({ l, onClick }) => (
  <NavLink
    to={l.to}
    onClick={onClick}
    data-testid={`nav-${l.id}-link`}
    className="text-sm text-trace-muted transition-colors duration-200 hover:text-white"
  >
    {l.label}
  </NavLink>
);

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 border-b border-trace-line/70 bg-trace-bg/75 backdrop-blur-xl">
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 sm:px-6 lg:px-8" aria-label="Main">
        <Logo />
        <div className="hidden items-center gap-8 md:flex">
          {LINKS.map((l) => <NavItem key={l.id} l={l} />)}
        </div>
        <Link
          to="/scan"
          data-testid="nav-launch-scanner-button"
          className="hidden items-center gap-2 rounded-full border border-trace-green/40 bg-trace-green/10 px-4 py-2 text-sm font-medium text-trace-green transition-colors duration-200 hover:bg-trace-green hover:text-trace-bg md:inline-flex"
        >
          <ScanSearch size={16} /> Launch scanner
        </Link>
        <button
          className="text-white md:hidden"
          onClick={() => setOpen(!open)}
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>
      {open && (
        <div className="flex flex-col gap-5 border-t border-trace-line bg-trace-panel px-6 py-6 md:hidden" data-testid="mobile-menu">
          {LINKS.map((l) => <NavItem key={l.id} l={l} onClick={() => setOpen(false)} />)}
        </div>
      )}
    </header>
  );
};
